import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/de/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__de-DE.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

type FaqItem = { question: string; answer: string };
const faqItems = (content as unknown as { faqItems: FaqItem[] }).faqItems || [];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item: FaqItem) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['de-DE'].layout },
  seo: {
    title: 'Hausrat & Privathafpflichtversicherung FAQ | Lemonade',
    metaTitle: 'Hausrat & Privathafpflichtversicherung FAQ | Lemonade',
    description:
      'Versicherungen können verwirrend sein, müssen es aber nicht!! Hier sind einige der häufigsten Fragen zu Lemonade - von der Hausrat bis hin zu dem, was unsere Privathaftpflichtversicherung abdeckt (und sogar, wie Versicherungsansprüche funktionieren!) Bonus? Du erfährst auch ein bisschen mehr über zusätzliche Deckungen und das Geschäftsmodell von Lemonade.',
    jsonld: [faqSchema],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
